
import React from 'react';
import '@nike/ruxac/styles';
import '../Styles/constants.scss';

import Navbar from '../../../Navbar';
import config from '../../../../config/oAuthConfig'
import { loginUser } from '../../../auth/index';
import { useDispatch } from 'react-redux';

export  const ErrorMessage = ({ children }) => {
    const dispatch = useDispatch();
    return (
<div>
        <Navbar
                
        appTitle="PCX Data Loader App"
        loginComponent={<a onClick={() => dispatch({ type: loginUser.type })} href={config.pathName} >Login</a>}
       
        />

        <div className="error-message-container">
            
           <h3>You are not an authorized user of this application. Please contact Frontline Support to request access.</h3>
        </div>
        </div>
    );
}
export default ErrorMessage;
